// Standard status codes
export enum ResponseStatus {
    INTERNAL_SERVER_ERROR = 500,
    NOT_FOUND = 404,
}
